//Router
import { createBrowserRouter, Navigate } from "react-router-dom";

// Layout
import AdminBase from "../pages/private/Admin/base/AdminBase";

// Public
import Redirect from "../pages/private/Admin/base/Redirect";
import Login from "../pages/public/Login";
import Error from "../pages/user/Error";

//Private Admin
import Dashboard from "../pages/private/Admin/dashboard/Dashboard";
import Ranking from "../pages/private/Admin/ranking/Ranking";
import Matches from "../pages/private/Admin/matches/Matches";
import Players from "../pages/private/Admin/players/Players";
import Categories from "../pages/private/Admin/categories/Categories";

//Private User
import UserBase from "../pages/private/User/base/UserBase";
import Home from "../pages/private/User/home/Home";
import MatchesUser from "../pages/private/User/matchesUser/MatchesUser";
import RankingUser from "../pages/private/User/rankingUser/RankingUser";
import Profile from "../pages/private/User/profile/Profile";
import Register from "../pages/public/Register";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
    children: [],
  },
  {
    path: "/register",
    element: <Register />,
    children: [],
  },
  {
    path: "/",
    element: <Navigate to="/login" />,
    children: [],
  },
  {
    path: "/user/error",
    element: <Error />,
    children: [],
  },
  {
    path: "/user/redirect",
    element: <Redirect />,
    children: [],
  },
  {
    path: "*",
    element: <Navigate to="/login" />,
    children: [],
  },
  {
    path: "/private/admin",
    element: <AdminBase size="md" />,
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
        children: [],
      },
      {
        path: "ranking",
        element: <Ranking />,
        children: [],
      },
      {
        path: "matches",
        element: <Matches />,
        children: [],
      },
      {
        path: "players",
        element: <Players />,
        children: [],
      },
      {
        path: "categories",
        element: <Categories />,
        children: [],
      },
    ],
  },
  {
    path: "/private/user",
    element: <UserBase size="md" />,
    children: [
      {
        path: "home",
        element: <Home />,
        children: [],
      },
      {
        path: "matches",
        element: <MatchesUser />,
        children: [],
      },
      {
        path: "ranking",
        element: <RankingUser />,
        children: [],
      },
      {
        path: "profile",
        element: <Profile />,
        children: [],
      },
    ],
  },
]);
